<script>
  import { M } from '../../../../../external';
  export let data = {
      commentId: '',
      parentChain: [],
      pollOptionId: '',
      pollOptionName: '',
      title: '',
      truncatedContent: '',
      refUrl: '',
      resourceType: '',
      resourceId: ''
    },
    contact;

  // we only use for walls but still.
  // This should work for every resource.
  // I would like to make this common later when someone else needs it
  const RESOURCE_QUERY_PARAM_MAPPING = {
    wall: 'wall',
    product_review: 'review',
    product_review_widget: 'review',
    video: 'video',
    discussion: 'discussion',
    standalone: 'comment'
  };

  const getResourceUrl = () => {
    const baseUrl = `https://${window.primaryDomain}${data.refUrl}`;
    const url = new URL(baseUrl);

    const mergedParams = new URLSearchParams(url.search);

    mergedParams.set(RESOURCE_QUERY_PARAM_MAPPING[data.resourceType], data.resourceId);
    if (data.parentChain) {
      const parentChainStr = data.parentChain.join(',');
      mergedParams.set('parent', parentChainStr);
    }

    url.search = mergedParams.toString();

    return url.toString();
  };

  const onClick = () => {
    window.open(getResourceUrl(), '_blank');
  };
</script>

{M.VOTED} <b>{data.pollOptionName}</b> → <b><a on:click={onClick} class="blue-text">{data.truncatedContent}...</a></b>
